import { formatRelative } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatRelativeBr(date, baseDate) {
  return formatRelative(date, baseDate, { locale: ptBR });
}

export function dayToWeekNumber(day) {
  const value = day.toLocaleUpperCase();
  switch (value) {
    case 'SUNDAY':
      return 0;
    case 'MONDAY':
      return 1;
    case 'TUESDAY':
      return 2;
    case 'WEDNESDAY':
      return 3;
    case 'THURSDAY':
      return 4;
    case 'FRIDAY':
      return 5;
    default:
      return 6;
  }
}
